import React from 'react';
import { MenuItem, TextField } from '@mui/material';

import { PROJECT_STATUSES, ProjectLayoutModel, ProjectStatus } from '@paragon/contract-library';
import { editLayoutModelProperties } from '@paragon/layout-models';

import { useAppDispatch } from './hooks';

interface Props {
  readonly project: ProjectLayoutModel;
}

export function ProjectStatusSelect({ project }: Props) {
  const dispatch = useAppDispatch();

  return (
    <TextField
      select
      size="small"
      label="Status"
      value={project.status}
      onChange={(event) =>
        dispatch(editLayoutModelProperties(project.guid, { status: event.target.value as ProjectStatus }))
      }
    >
      {PROJECT_STATUSES.map((status) => (
        <MenuItem key={status} value={status}>
          {status}
        </MenuItem>
      ))}
    </TextField>
  );
}
